// Texts for the world 'upsidedown': name on the map and the level titles, per language.
// The ids must be the level ids in levels.ts (npm run validate checks it); other languages must have the same ids as da (tsc).
import { defineWorldStrings } from '../../core/i18n';

export const strings = defineWorldStrings({
  da: {
    name: 'Omvendt land',
    levels: {
      'up': { title: 'Op!' },
      'arrow': { title: 'Pilen' },
      'cloud': { title: 'Skyen' },
      'flip-zone': { title: 'Vende-zonen' },
      'short-trip': { title: 'Kort tur' },
      'pot': { title: 'Potten' },
      'down-again': { title: 'Ned igen' },
      'hop-and-flip': { title: 'Hop og vend' },
      'tip-and-zone': { title: 'Vip og zone' },
      'snip-and-flip': { title: 'Klip og vend' },
      'honey': { title: 'Honning' },
      'pulley': { title: 'Trissen' },
      'into-the-basket': { title: 'Ned i kurven' },
      'toaster': { title: 'Brødristeren' },
      'big-machine': { title: 'Den store maskine' },
    },
    scene: { whoops: 'HOVSA!' },
  },
  en: {
    name: 'Upside-down land',
    levels: {
      'up': { title: 'Up!' },
      'arrow': { title: 'The arrow' },
      'cloud': { title: 'The cloud' },
      'flip-zone': { title: 'The flip zone' },
      'short-trip': { title: 'A short trip' },
      'pot': { title: 'The pot' },
      'down-again': { title: 'Down again' },
      'hop-and-flip': { title: 'Hop and flip' },
      'tip-and-zone': { title: 'Tip and zone' },
      'snip-and-flip': { title: 'Snip and flip' },
      'honey': { title: 'Honey' },
      'pulley': { title: 'The pulley' },
      'into-the-basket': { title: 'Into the basket' },
      'toaster': { title: 'The toaster' },
      'big-machine': { title: 'The big machine' },
    },
    scene: { whoops: 'WHOOPS!' },
  },
});
